import { render, staticRenderFns } from "./form-wizard.vue?vue&type=template&id=2fc62cba&scoped=true&"
import script from "./form-wizard.vue?vue&type=script&lang=js&"
export * from "./form-wizard.vue?vue&type=script&lang=js&"
import style0 from "./form-wizard.vue?vue&type=style&index=0&id=2fc62cba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc62cba",
  null
  
)

export default component.exports